import React from 'react';
import { Sasquatch153x192 } from '@bamboohr/grim';

export const DEFAULT_ICON_JADE = <Sasquatch153x192 aria-label="Sasquatch" />;
export const DEFAULT_TITLE_JADE = window.jQuery ? $.__(`There's nothing to see here...`) : `There's nothing to see here...`;
